import {
    cacheStorage,
} from '@/utils'
// import router from '_merchant/router'
//数据持久化插件
// import createPersistedState from 'vuex-persistedstate'

/**
 * 权限 store模块
 */
export default {
    state: {
        token: cacheStorage.getItem(process.env.VUE_APP_AUTH_TOKEN),
        // 当前用户信息
        user: JSON.parse(cacheStorage.getItem(process.env.VUE_APP_USER)),
        // 平台管理的默认商家id为0， 在商家管理端需要真实的id
        tenancyId: localStorage.getItem('tenancyId') || null,
        corpId: localStorage.getItem('corpId') || '',
        cpType: localStorage.getItem('cpType') || null,
        cpCode: localStorage.getItem('cpCode') || '',
        externalUserId: localStorage.getItem('externalUserId') || '',
        qwAccountId: localStorage.getItem('qwAccountId') || '',
    },
    mutations: {
        setToken (state, token) {
            state.token = token
        },
        setUser (state, user) {
            state.user = user
        },
        /**
         * 登出
         * @param state
         */
        layout (state) {
            // 清除缓存， 认证token,用户信息,然后跳转到登录页面
            cacheStorage.clear()
            state.token = null
            state.user = null
            state.tenancyId = null
            // router.push({
            //     name: 'login'
            // })
        },
        setTenancyId (state, tenancyId) {
            state.tenancyId = tenancyId
        },
        setCorpId (state, corpId) {
            state.corpId = corpId
        },
        setMemberId (state, memberId) {
            state.memberId = memberId
        },
        setCpType (state, cpType) {
            state.cpType = cpType
        },
        setCpCode (state, cpCode) {
            state.cpCode = cpCode
        },
        setExternalUserId (state, externalUserId) {
            state.externalUserId = externalUserId
        },
        setQwAccountId (state, qwAccountId) {
            state.qwAccountId = qwAccountId
        },
    },
    actions: {
        setToken (context, token) {
            context.commit('setToken', token)
            cacheStorage.setItem(process.env.VUE_APP_AUTH_TOKEN, token)
        },
        setUser (context, user) {
            context.commit('setUser', user)
            cacheStorage.setItem(process.env.VUE_APP_USER, JSON.stringify(user))
        },
        setTenancyId (context, tenancyId) {
            context.commit('setTenancyId', tenancyId)
            cacheStorage.setItem(process.env.VUE_APP_MERCHANT_ID, tenancyId)
        },
        logout (context) {
            context.commit('layout')
        },
        setCorpId (context, corpId) {
            context.commit('setCorpId', corpId)
            localStorage.setItem('corpId', corpId)
        },
        setMemberId (context, memberId) {
            context.commit('setMemberId', memberId)
            localStorage.setItem('memberId', memberId)
        },
        setCpType (context, cpType) {
            context.commit('setCpType', cpType)
            localStorage.setItem('cpType', cpType)
        },
        setCpCode (context, cpCode) {
            context.commit('setCpCode', cpCode)
            localStorage.setItem('cpCode', cpCode)
        },
        setExternalUserId (context, externalUserId) {
            context.commit('setExternalUserId', externalUserId)
            localStorage.setItem('externalUserId', externalUserId)
        },
        setQwAccountId (context, qwAccountId) {
            context.commit('setQwAccountId', qwAccountId)
            localStorage.setItem('qwAccountId', qwAccountId)
        },
    },
    // plugins: [createPersistedState()]
}
